// Tab name constants for POR document views
export const DOCUMENTS = 'documents';
export const INVENTORY = 'inventory';
export const CLOSEOUT_HISTORY = 'closeout history';
export const PROGRESS_REPORTS = 'progress reports';



// WEBPACK FOOTER //
// ./src/constants/TabConstants.js